import type { AnalyticsItem } from '@src/domains/analytics/types/analytics';

type ProductLike = {
  product: { id: string; name: string };
};

export const getAnalyticsItems = <T extends ProductLike>(items: T[]): AnalyticsItem[] =>
  items.map((item) => ({ item_id: item.product.id, item_name: item.product.name }));
